<template>
  <div>
    <v-col cols="12" class="text-center">
      <h3 class="mb-4">¿Está seguro de que desea desvincular de esta convocatoria a este personal?</h3>
      <p class="white--text mb-4">{{ personalData?.nombreCompleto || 'Personal seleccionado' }}</p>
      <v-row>
        <v-col cols="6">
          <TextButton color="error" @click="cancelar"> Cancelar </TextButton>
        </v-col>
        <v-col cols="6">
          <TextButton @click="confirmar"> Confirmar </TextButton>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@/components/base/TextButton.vue'

export default {
  name: 'MensajeConfirmacionEliminarPersonalConvocatoria',
  components: { TextButton },

  props: {
    personalData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    confirmar() {
      this.$emit('confirmed')
      this.$emit('close')
    },

    cancelar() {
      this.$emit('cancelled')
      this.$emit('close')
    },
  },
}
</script>
